import { render, staticRenderFns } from "./CConfirm.vue?vue&type=template&id=18c08848&scoped=true"
import script from "./CConfirm.vue?vue&type=script&lang=js"
export * from "./CConfirm.vue?vue&type=script&lang=js"
import style0 from "./CConfirm.vue?vue&type=style&index=0&id=18c08848&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c08848",
  null
  
)

export default component.exports